import svg4everybody from 'svg4everybody';
import picturefill from 'picturefill';

import 'core-js/es/promise';
import 'core-js/es/symbol';
import 'core-js/features/object/entries';
import 'core-js/features/object/values';
import 'core-js/features/object/assign';
import 'core-js/features/array/find';
import 'core-js/features/array/from';

export function runPolyfills() {
    svg4everybody();
    picturefill();
}

// classList.toggle force polyfill
if (!DOMTokenList.prototype.toggle || document.createElement("div").classList.toggle("a", 0)!==false) DOMTokenList.prototype.toggle=function(val){
    if (arguments.length > 1) return (this[arguments[1] ? "add" : "remove"](val), !!arguments[1]);
    var oldValue = this.value;
    return (this.remove(oldValue), oldValue === this.value && (this.add(val), true) /*|| false*/);
};

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}